import { createSelector } from 'reselect'
import initParametersSelector from './initParametersSelector'

const isTranslationDebugEnabledSelector = createSelector(
    initParametersSelector,
    (initParameters): boolean => initParameters.debugTranslationText === 'true',
)

export default isTranslationDebugEnabledSelector
